import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import ParticlesBg from "particles-bg";

let config = {
  num: [8, 12],
  rps: 0.1,
  radius: [10, 80],
  life: [1.5, 3],
  v: [1, 1.5],
  tha: [-40, 40],
  alpha: [0.6, 0],
  scale: [0.1, 0.4],
  position: "all",
  color: ["random", "#ffffff"],
  cross: "dead",
  // emitter: "follow",
  random: 15,
};

// if (Math.random() > 0.85) {
//   config = Object.assign(config, {
//     onParticleUpdate: (ctx, particle) => {
//       ctx.beginPath();
//       ctx.rect(
//         particle.p.x,
//         particle.p.y,
//         particle.radius * 20,
//         particle.radius * 20
//       );
//       ctx.fillStyle = particle.color;
//       ctx.fill();
//       ctx.closePath();
//     },
//   });
// }

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
      <ParticlesBg
        type="circle"
        config={config}
        bg={{
          position: "fixed",
          zIndex: -1,
          top: 0,
          left: 0,
        }}
        // color="#DA7B93"
      />
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
